import type { ReactNode } from "react";
import { styled } from "styled-components";

import { ListLink } from "common/components/lists/ListLink";
import { LatestViewInnerContent } from "domains/knowledgeData/components/SharedComponents";
import type { KnowledgeType, Source } from "entities/knowledge/types";

const StyledLink = styled(ListLink)`
  text-decoration: none;
`;

type KnowledgeDataNavigationalItemLatestViewProps = {
  articleAnnouncement?: ReactNode;
  title: string;
  imageUrl?: string;
  knowledgeType: KnowledgeType;
  source: Source;
  timestamp?: number;
  detailLink?: string;
  externalLink: string;
};

export const KnowledgeDataNavigationalItemLatestView = ({
  title,
  imageUrl,
  knowledgeType,
  source,
  timestamp,
  articleAnnouncement,
  detailLink,
  externalLink,
}: KnowledgeDataNavigationalItemLatestViewProps) => (
  <StyledLink to={externalLink}>
    <LatestViewInnerContent
      title={title}
      imageUrl={imageUrl}
      knowledgeType={knowledgeType}
      source={source}
      timestamp={timestamp}
      link={detailLink}
      articleAnnouncement={articleAnnouncement}
    />
  </StyledLink>
);
